import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop, modelOptions } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
@InputType('FileInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class File extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  uri: string

  @Field(() => String)
  @Prop({ type: String })
  mimetype: string

  @Field(() => String)
  @Prop({ type: String })
  encoding: string

  @Field(() => String)
  @Prop({ type: String, index: true })
  description?: string

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String], required: false, default: undefined })
  directoryTree?: string[]

  // Optional storage-identifying fields
  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  bucket?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  key?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  etag?: string

  @Field(() => Number, { nullable: true })
  @Prop({ type: Number, required: false })
  size?: number

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  checksum?: string
}
